import { createFileRoute } from '@tanstack/react-router';

import { PatentCreate } from '@/module/Author/Patent/PatentCreate';

export const Route = createFileRoute('/_auth/author/_author/patent/_patent/create')({
  component: RouteComponent,
  staticData: {
    pageTitle: { id: 'pageTitle.create' },
  },
});

function RouteComponent() {
  return <PatentCreate />;
}
